// Single source of truth for the patient portal nav. The left rail (desktop)
// and the bottom nav (mobile) both pull from this list — keep them aligned.
//
// `mobile: true` marks the items that surface in the mobile bottom tab bar
// (5 most-used per docs/PATIENT_PORTAL_PLAN.md §4.2).

export const PATIENT_NAV_ITEMS = [
  { id: 'today', label: 'Today', icon: '🏠', to: '/patient-home', exact: true, mobile: true },
  { id: 'care', label: 'Care', icon: '🌿', to: '/patient-home/care', mobile: true, mockOnly: true },
  { id: 'assessments', label: 'Assessments', icon: '📋', to: '/patient-home/assessments' },
  { id: 'sessions', label: 'Sessions', icon: '📅', to: '/patient-home/sessions', mobile: true },
  { id: 'practitioners', label: 'Practitioners', icon: '🩺', to: '/patient-home/practitioners' },
  { id: 'records', label: 'Records', icon: '📄', to: '/patient-home/records' },
  { id: 'messages', label: 'Messages', icon: '💬', to: '/patient-home/messages', mobile: true, mockOnly: true },
  { id: 'shop', label: 'Shop', icon: '🛒', to: '/patient-home/shop', mockOnly: true },
  { id: 'profile', label: 'Profile', icon: '👤', to: '/patient-home/profile', mobile: true },
  { id: 'help', label: 'Help', icon: '❓', to: '/patient-home/help' },
]
